import React from 'react';
import request from '../utils/axios/request';
import { NavigateFunction } from 'react-router-dom';
import Cookies, { IToken } from '../lib/cookies';

// Authentication service class for sign in and sign off
abstract class AuthService {
	static async login(
		email: string,
		password: string,
		keepConnected: boolean,
		setError: React.Dispatch<React.SetStateAction<string>>
	) {
		try {
			const data: IToken = await request(
				'/auth/login',
				'post',
				{ data: { email, password } },
				'guest'
			);
			Cookies.setAccessToken(data, keepConnected);
			return data;
		} catch (error: any) {
			if (error?.response) setError('alert.error.login');
		}
	}

	static async loginClient(
		email: string,
		password: string,
		keepConnected: boolean,
		setError: React.Dispatch<React.SetStateAction<string>>
	) {
		try {
			const data: IToken = await request(
				'/auth/contact/login',
				'post',
				{ data: { email, password } },
				'guest'
			);
			Cookies.setClientAccessToken(data, keepConnected);
			return data;
		} catch (error: any) {
			if (error?.response) setError('alert.error.login');
		}
	}

	static async generateToken(
		email: string,
		setError: React.Dispatch<React.SetStateAction<string>>,
		isClient?: boolean
	) {
		try {
			const URL = isClient
				? '/auth/contact/token/generate'
				: '/auth/token/generate';
			const data = await request(URL, 'post', {
				data: { email },
			});
			return data;
		} catch (error: any) {
			if (error?.response) setError('alert.error.email_inexistent');
		}
	}

	static async verifyToken(token: string) {
		const data = await request(
			'/auth/token/verify',
			'post',
			{ data: { token } },
			'guest'
		);
		return data;
	}

	static async resetPassword(
		token: string,
		password: string,
		setError: React.Dispatch<React.SetStateAction<string>>,
		isClient: boolean
	) {
		try {
			const URL = isClient
				? '/auth/contact/reset_password'
				: '/auth/reset_password';
			const data = await request(URL, 'post', {
				data: { token, password },
			});
			return data;
		} catch (error: any) {
			if (error?.response) setError('alert.error.token');
		}
	}

	static logout(navigate: NavigateFunction) {
		Cookies.clear();
		navigate('/login');
	}
}

export default AuthService;
